import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import { formatNumberValue } from '@helpers/utils';
import { withMotion } from '@hoc/withMotion';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import { animate, useReducedMotion } from 'framer-motion';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { useCookies } from 'react-cookie';
import S from './AlertsBanner.styles';
const AlertsBanner = (props) => {
    const prefersReducedMotion = useReducedMotion();
    const cookieName = props.name ?? 'notification-cookie';
    const [cookies, setCookie] = useCookies([cookieName]);
    const [animation, setAnimation] = React.useState(false);
    const [count, setCount] = React.useState(wrapNumbers(formatNumberValue(props.count?.from ?? 0, 0, 2).split('')));
    /** After .6s set animate state to true so banner will slide in if it should be displayed */
    React.useEffect(() => {
        setTimeout(() => setAnimation(true), 600);
    }, []);
    /** If using count, count up once the banner has slid in */
    React.useEffect(() => {
        if (!props.count) {
            return;
        }
        const value = props.count?.to ?? 0;
        // Only perform animation if user hasn't doesn't prefer reduced motion
        if (prefersReducedMotion) {
            const numbers = formatNumberValue(value, 0, 2).split('');
            const number = wrapNumbers(numbers);
            setCount(number);
        }
        else {
            const controls = animate(props.count.from, value, {
                type: 'tween',
                delay: 1.5,
                duration: 1.5,
                ease: 'easeOut',
                onUpdate(val) {
                    const numbers = formatNumberValue(val, 0, 2).split('');
                    const number = wrapNumbers(numbers);
                    setCount(number);
                },
            });
            return () => controls.stop();
        }
    }, [props.count?.to]);
    if (!props.text) {
        return null;
    }
    return (React.createElement(S.Container, { "data-type": props.type, "data-visible": !cookies[cookieName] && animation },
        React.createElement(S.Banner, null,
            React.createElement("span", null,
                props.title && React.createElement(S.Label, null, props.title),
                React.createElement(S.BannerText, { dangerouslySetInnerHTML: {
                        __html: props.count ? props.text.replace('##count##', count) : props.text,
                    } })),
            props.cta && (React.createElement(React.Fragment, null,
                React.createElement(S.Divider, null),
                React.createElement("span", { "data-variant": "light" },
                    React.createElement(LinkButton, { branding: "outline", href: props.cta.url, target: props.cta.target, title: props.cta.text ?? `Read More` })))),
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.Close, { "aria-label": "Dismiss Banner", onClick: () => setCookie(cookieName, true, { path: '/', maxAge: 24 * 60 * 60 }) }, getSvgFromSystem(SystemIcon.Cross))))));
    function wrapNumbers(value) {
        return value.map((n) => `<span>${n}</span>`).join('');
    }
};
export default withMotion(AlertsBanner);
